import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "menu"];

  initialize() {
    this.reposition = this.reposition.bind(this);
  }

  disconnect() {
    this.stopFollowingAnchor();
  }

  onBeforeToggle(event) {
    if (event.newState === "open") this.position();
  }

  close() {
    if (this.menuTarget.matches(":popover-open")) {
      this.menuTarget.hidePopover();
    }
  }

  stopRowClick(event) {
    if (event.target.closest("a, button")) return;

    event.stopPropagation();
  }

  syncExpanded(event) {
    const open = event.newState === "open";
    this.buttonTarget.setAttribute("aria-expanded", open);

    if (open) {
      this.startFollowingAnchor();
    } else {
      this.stopFollowingAnchor();
    }
  }

  reposition() {
    if (this.menuTarget.matches(":popover-open")) {
      this.position();
    }
  }

  position() {
    const anchor = this.buttonTarget.getBoundingClientRect();
    const menu = this.menuTarget;

    menu.style.position = "fixed";
    menu.style.top = `${anchor.bottom + 4}px`;
    menu.style.left = "auto";
    menu.style.right = `${Math.max(8, window.innerWidth - anchor.right)}px`;
  }

  startFollowingAnchor() {
    window.addEventListener("scroll", this.reposition, { capture: true, passive: true });
    window.addEventListener("resize", this.reposition);
  }

  stopFollowingAnchor() {
    window.removeEventListener("scroll", this.reposition, { capture: true });
    window.removeEventListener("resize", this.reposition);
  }
}
